<template>
  <div v-if="$store.state.user.permissions.user_show" class="user">
    <BaseTable
        :settings="settings" 
        :fields="fields"
        :items="result"
        :searchTerm="$store.state.searchTerm"
        sortBy="familyname"
        sortOrder="desc"
        rowClass="familyname"
        tableId="1" />
  </div>
</template>

<script>
import EventBus from "../bus";
import BaseTable from "../components/table/_BaseTable";
import functions from '../mixins/functions';
export default {
  name: 'user',
  mixins: [functions],
  data () {
    return {
      result: [],
      settings: { rowMax: 25, searchinput: false },
      fields: [
        { label: "Loginname", show: "loginname"},
        { label: "Vorname", show: "prename"},
        { label: "Nachname", show: "familyname"},
        { label: "E-Mail", show: "email"},
        { label: "Registrierungsdatum", show: "regdate", classes: ["center", "nowrap"], hclasses: ["center"], width: "150px", sort: "regdate_sort", type: "datetime"},
        { label: "Letzter Besuch", show: "lastonline", classes: ["center", "nowrap"], hclasses: ["center"], width: "100px", sort: "lastonline_sort", type: "datetime"},
        { label: "", show: "Benutzer löschen", type: "button", event: "deleteUser", classes: ["center", "button", "img-delete"]},
        { label: "", show: "Benutzer editieren", type: "button", event: "editUser", classes: ["center", "button", "img-edit"]},
      ],
    }
  },
  created: function (){
    this.resetBar();
    this.$store.state.bar.search = true

    if(this.$store.state.user.permissions.generally_export_data){
      this.$store.state.bar.exportToExcel = true
    }
    if(this.$store.state.user.permissions.user_add){
      this.$store.state.bar.add = true
    }
    
    //this.$store.state.bar.view = true
    //this.$store.state.bar.setting = true

    this.$store.state.isLoading = true
    this.$store.state.heading = "Benutzerübersicht"
    this.$http.get('/api/get_user.pl').then(function (response) {
        console.log(response.data);
        this.result = response.data.users
        this.$store.state.isLoading = false
        response.data.dberror.hasError ? EventBus.$emit("showinfo", "error", response.data.dberror.errorText, 15) : undefined
        EventBus.$emit("showinfo", response.data.callmessage, response.data.message, response.data.timesecmessage)
    });
  },
  mounted: function () {
    EventBus.$emit("checklogin")
    EventBus.$on("deleteUser", (item) => {
      
    });
    EventBus.$on("editUser", (item) => {
      this.$router.push({ name: 'editUser', params: { user_id: item.user_id } })
    });
    EventBus.$on("add", (item) => {
      this.$router.push({ name: 'newUser' })
    });
  },
  components: {
    BaseTable
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/pages/User.vue